export const PALO_ALTO_CRITERIA = {
  PALO_ALTO: [
    {
      Criteria: "Price",
      Model: "Insourcing/Co-Managed",
      Questions: "Hardware Price Available?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Price",
      Model: "Outsourcing",
      Questions: "Price per site Tier Available?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Price",
      Model: "Insourcing/Co-Managed",
      Questions: "Licensing (# users, bandwidth, length of time, fixed)",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Hardware Availability",
      Model: "All",
      Questions: "How available is the necessary hardware? (Lead times)",
      Check: "Yes",
      Rating: 3,
      Notes: "2 Weeks",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "How is path selection determined? (jitter, latency, packet loss)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN utilizes real application flows in addition to jitter, loss, and latency.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can path selection be dynamically configured?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "What path selection options can be set?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN allows the administrator to choose from Direct, Prisma SD-WAN Fabric VPNs, SSE, and/or Standard IPSec VPNs for each application or group of applications.",
    },
    {
      Criteria: "Path Selection",
      Model: "Insourcing/Co-Managed",
      Questions: "Can traffic be tagged based on rules?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can traffic be prioritized based on QOS or traffic tags?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can path load sharing be configured?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can traffic steering be configured?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can the solution utilize traffic shaping to prioritize traffic for critical applications?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can the solution automatically select the best transport layer path based on performance metrics?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can the solution offer automated network failover?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can the solution optimize access to popular SaaS applications?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "Insourcing/Co-Managed",
      Questions: "Are there AI features for path selection?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Does solution detect and respond to a link-layer brownout? How?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, Prisma SD-WAN can detect congestion, degradation and failures. The solution stands out in its ability to detect congestion, degradation, or failures at both the network and application levels. By continuously monitoring network conditions and application performance metrics such as Round Trip Latency (RTT) and TCP transactions, the system swiftly identifies issues. Upon detection, Prisma SD-WAN seamlessly redirects the flow to an available and improved path, utilizing application affinity for a smooth transition. All new flows automatically route through the superior path until the initially affected path returns to normal health. This proactive approach ensures uninterrupted and optimal end-user experiences by promptly adapting to and mitigating network challenges.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can solution detect and respond to an application brownout? How? ",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN is application-defined, allowing customers to make path, Quality of Service (QoS), and security decisions based on Layer 7 information. Additionally the solution continously monitors application performance through Layer 4 to Layer 7 metrics allowing the capability to intelligently shift applications to paths with superior performance or trigger features such as Forward Error Correction (FEC), packet duplication, or application acceleration for optimized and responsive network experiences. \r\n\r\nFurthermore, Prisma SD-WAN natively integrates with Prisma Access providing cloud-delivered Next-Generation Firewall (NGFW) protection across all users, applications, and devices. This integrated approach ensures comprehensive security for a wide range of network elements, enhancing overall protection in the cloud environment.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Describe the system's link selection capabilities. Are they available per application?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN can identify a broad range of enterprise, SAAS and media applications (e.g., Office-365 voice & video, Google-docs, SFDC, SAP, etc.) to the sub-application without decrypting. The seamless local real-time identification of application signatures takes place for each flow, enabling a thorough analysis of performance metrics like Mean Opinion Score (MOS), app performance, and app reachability for every application. These real-time statistics play a key role in making intelligent path selection decisions, guaranteeing the most efficient network routing. Furthermore, the solution consistently monitors application performance by leveraging Layer 4 to Layer 7 metrics. This capability enables the intelligent adjustment of applications to paths with superior performance and the activation of features such as Forward Error Correction (FEC), packet duplication, or application acceleration. This ensures optimized and responsive network experiences for users.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "How does the solution monitor application reachability across multiple links?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN uses real-time user flows and application sessions to determine reachability.  This applies to all paths available to the application as defined in the Prisma SD-WAN path policies.  Application metrics (RTT, MOS, Init failures)",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Describe how the solution handles end-user connections (TCP flows) when traffic has to be moved from one link to another. Are sessions terminated or maintained?",
      Check: "Yes",
      Rating: 3,
      Notes:
        'For System and Custom TCP applications - the end user has control and flexibility on how these applications are handled.  By default, existing flows and sessions will move according to the application defined "path affinity."',
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "How does the solution maintain flow symmetry and correct flows when asymmetry is detected?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes; Prisma SD-WAN natively corrects asymmetric routing.  This allows for traffic to enter one data center (DC1), traverse to another data center (DC 2), then come back to the branch on another VPN/connection.  Traffic will then collapse and go back and forth between the branch and DC2.",
    },
    {
      Criteria: "Transport Layer Connectivity",
      Model: "All",
      Questions:
        "Can the solution support all types of WAN transport layer connection types?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN supports ethernet handoff(s) - Copper, Fiber (SFP/SFP+) for LAN and WAN circuits.  In addition certain models support integrated 5G/LTE cellular connectivity.",
    },
    {
      Criteria: "Transport Layer Connectivity",
      Model: "All",
      Questions:
        "All transport layer technologies are supported? Which ones are not?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN supports ethernet handoff(s) - Copper, Fiber (SFP/SFP+) for LAN and WAN circuits.  In addition certain models support integrated 5G/LTE cellular connectivity. ",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "All",
      Questions: "Are Dynamic Protocols supported? Please list.",
      Check: "Yes",
      Rating: 2,
      Notes: "BGP and OSPF are supported for LAN and WAN communication.",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "All",
      Questions:
        "Does the solution operate without restrictions to any protocols?",
      Check: "Yes",
      Rating: 2,
      Notes: "BGP and OSPF are supported for LAN and WAN communication.",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Are there any routing best practices for the product? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        'Prisma SD-WAN leverages BGP connectivity in the Datacenter (Hubs) to distribute the branch prefixes to the DC Core.  Prisma SD-WAN has automatic prefix-list and as-prepends to allow for seamless integration into existing DCs when creating the peering relationship.  This is achieved by selecting the peer-type of "Core" when creating the BGP peer(s) within the Hub(s).',
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Outsourcing",
      Questions:
        "Can the Client control routes at the edge in the MSP scenario?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can the solution support multiple circuit carriers in active/active connection setup?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Can routing be controlled at the edge?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Routing for the LAN Layer 3 component is configurable on the edge devices.  Prisma SD-WAN provides a policy driven approach to path selection on the edge for WAN, Prisma SD-WAN Fabric, SSE, or Direct to internet access.",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does solution not require data-plane traffic to transit through single or multiple POPs (Point of Presence). Does solution operate without remote GW requirement?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Data plane traffic does not rely on the controller or a POP (sometimes called a GW).  Path Selection and application performance is performed on the edge device and programmed via the control plane (controller) for Prisma SD-WAN.",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "All",
      Questions:
        "How does the solution integrate natively with existing MPLS WAN networks? Can the overlay and underlay be used simultaneously?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN offers a flexible approach to migration, providing various deployment options to suit different needs. In the data center, our solution can be implemented off-path, ensuring seamless connectivity for branch devices without disrupting existing data center applications or introducing complex routing requirements.\r\n\r\nAt the branch level, our solution allows deployment behind existing Customer Premises Equipment (CPE) devices, facilitating a gradual removal of additional equipment such as CPE, firewall, or switches. This approach simplifies both cost and operational complexity, providing a smooth transition as organizations evolve their network infrastructure.\r\n\r\nFurthermore, we support the use of both overlay and underlay networking, enabling direct communication with existing legacy branches via MPLS or standard VPN tunnels during migration. This flexibility ensures a seamless transition phase, allowing organizations to maintain connectivity with legacy infrastructure while gradually transitioning to our SD-WAN solution.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions: "Does the solution offer redundancy options (specify)? ",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The solution is meticulously architected to deliver high availability across the application, device, and network levels. At the application level, automatic detection ensures swift identification of unreachable applications on a specific path, even if the path is operational at Layer 3. This proactive approach guards against application-specific issues like brownouts or routing loops, enhancing overall reliability and troubleshooting efficiency.\r\n\r\nAt the device level within the branch, the solution offers inline fail-to-wire capabilities. In the event of device failure, the system ensures that the full cross-sectional bandwidth of all circuits in the branch remains available to the remaining device, optimizing end-user performance.\r\n\r\nOn the network level, continuous monitoring of link quality, availability, and application performance on specific links allows for intelligent path selection decisions. This dynamic approach enables the system to avoid a given network path for one or more applications if it violates Service Level Agreements (SLAs), ensuring a robust and responsive network infrastructure.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Is there no requirement for additional equipment besides the redundant SD-WAN appliance?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "An additional ION is required for HA operation.  Also, for power level redundancy some models require an additional power supply.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Outsourcing",
      Questions: "What are failover and recovery speeds?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution include HA capabilities without requiring additional licensing? If not, please describe the licensing structure.",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution work without WAN-side switches and/or unique ISP addresses?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "In a High Availability (HA) configuration at the branch, the system guarantees seamless connectivity, uninterrupted services, and sustained bandwidth even if a single member within the HA pair encounters a failure. \r\n\r\nHarnessing the power of our inline fail-to-wire (RJ-45) capabilities, the system ensures that, in the event of device failure, the full cross-sectional bandwidth of all circuits in the branch is immediately made available to the remaining device. This optimized design prioritizes end-user performance, ensuring a resilient and efficient network experience.\r\n",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions:
        "Does the solution support fail-to-wire interfaces (multi-networking failover interfaces)?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can and how does the solution operate when it is unable to communicate with its controller or orchestration function (if any)?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "In the event of an orchestrator or controller outage, the data path is not affected. The cloud portal is part of the control plane and separate from the data plane, and it does not need to be connected to the branch or data center sites to allow traffic to flow.  \r\nIn the event that connectivity from the cloud controller is lost, the IONs are also designed to run in this ‘disconnected’ state for 3 days by default; after three days, some automatic overlay tunnels will stop being formed due to lack of shared secret seeding from the controller.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions:
        "Does the solution support link capacity monitoring without flooding the link?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN performs low-level, non-impacting circuit capacity reads for configured WAN circuits.  Additionally, this information is used to power Predictive analytics and information regarding improperly configured circuit speeds, or circuits that are not performing at their rated speeds from the carrier.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions:
        "Does the solution maintain 100% of the WAN capacity in the event of a unit failure?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN provides state of the art Resiliency and High Availability model at the Branch.  The HA model uses all the circuits in active/active fashion even when one of the devices fails thereby it uniquely maintains 100% of the WAN capacity during both steady state and device failure conditions.",
    },
    {
      Criteria: "Geographic Coverage",
      Model: "All",
      Questions: "Are there no geographic deployment restrictions?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "We deliver regional specific product features for regional data sovereignty and compliance requirements including GDPR. These include auto-selection of encryption type for China, policy-based geo-fencing to ensure client data only traverses Prisma SD-WAN, and third party transit nodes that meet sovereignty requirements, regional controller instances.\r\nhttps://www.paloaltonetworks.com/cyberpedia/how-the-next-generation-security-platform-contributes-to-gdpr-compliance",
    },
    {
      Criteria: "Geographic Coverage",
      Model: "All",
      Questions:
        "What is the experience utilizing the solution in countries like China?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN has design recommendations and considerations for deployment within China as well as numerous successful customer deployments.  ",
    },
    {
      Criteria: "Support",
      Model: "Insourcing",
      Questions: "Is solution documentation access available?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN documentation is available at: https://docs.paloaltonetworks.com/prisma-sd-wan",
    },
    {
      Criteria: "Support",
      Model: "Insourcing",
      Questions: "Are training options available?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Palo Alto Networks offers multiple training options including Self Paced Digital Learning and Instructor lead courses.  (https://www.paloaltonetworks.com/services/education) Digital Learning is available through our Beacon Platform.  The Digital Learning  covers: Prisma SD-WAN infrastructure, how applications form the fundamental component of the Prisma SD-WAN solution, the CloudBlades platform, and DevOps-style automation. Additionally, learn the static and BGP routing topologies, alerts and alarms, branch devices, services, multitenancy aspects of the Prisma SD-WAN cloud controller, and how to troubleshoot network, device, and application issues.  Our Standard Instructor lead course, EDU-238 (https://www.paloaltonetworks.com/services/education/edu-238-prisma-sd-wan-design-and-operation), is 5 Days of hands-on experience that will help enhance an attendees understanding of how to design, implement, and effectively operate a Prisma SDWAN solution.  Palo Alto Networks and our partners can also provide custom training on request.  In addition to standard offers we provide regular learning opportunities via Webinars across Regional Events",
    },
    {
      Criteria: "New Rollout",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution offer Zero Touch Provisioning?  If so, please describe the process.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN deployment is pure plug-n-play and we support Zero Touch Provisioning over any type of WAN. Customers are deploying hundreds of branches a week using the ZTP functionality of the solution.\r\nZTP is facilitated via UI integrated site template functionality. Alternatively customers can use API and SDK utitilties for automated Zero Touch Provisioning.",
    },
    {
      Criteria: "New Rollout",
      Model: "Insourcing/Co-Managed",
      Questions:
        "If ZTP is offered, does it operate without special DNS/DHCP records?",
      Check: "Yes",
      Rating: 3,
      Notes: "No special DHCP or DNS records need to be created. ",
    },
    {
      Criteria: "New Rollout",
      Model: "All",
      Questions:
        "Does the solution offer integration with Legacy Infrastructures?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "New Rollout",
      Model: "Insourcing/Co-Managed",
      Questions: "Is there a templating feature? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, Prisma SD-WAN sites can be deployed in advanced using UI tools such as Site Templates or using netdevops tools such as our python SDK combined with the cloudgenix_config utility.  When it is time to associate the hardware / virtual machine with the associated site/device configuration this is done via a simple association operation.  ",
    },
    {
      Criteria: "New Rollout",
      Model: "All",
      Questions: "How many hours does a new site turn-up normally take?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN customers typically perform a new site turn up within 5-15 minutes in most scenarios.  Time to value wise customers have deployed upwards of 70+ sites in a single work week on a consistent basis.",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions: "Are there no node limitations or restrictions?",
      Check: "Yes",
      Rating: 3,
      Notes: "Prisma SD-WAN does not require bookend nodes.",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions: "Are there no tunnel limitations or bandwidth?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN supports up to 5Gbs+ throughput at Branch sites and 14Gbs per device in the Hub or DataCenter.  Data Center devices are clustered for redundancy and supports horizontal scaling for additional throughput or tunnel scale if needed.  ",
    },
    {
      Criteria: "Scalability",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Are there no limitations on logical WAN interfaces? If so, please describe ",
      Check: "Yes",
      Rating: 3,
      Notes:
        "WAN interfaces support VLAN segmentation if required.  Up to 4096 VLANs are supported on the Prisma SD-WAN device(s).",
    },
    {
      Criteria: "Scalability",
      Model: "Insourcing/Co-Managed",
      Questions:
        "No deployment architecture options and limitations? (little interest in hub & spoke)",
      Check: "Yes",
      Rating: 3,
      Notes: "Hub and Spoke as well as Partial/Full mesh are supported.",
    },
    {
      Criteria: "Scalability",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution support hub and spoke VPN topologies? Are multiple hubs supported?  (little interest in hub & spoke)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN supports multiple hubs (physical, virtual, or cloud based) to access applications and resources.",
    },
    {
      Criteria: "Scalability",
      Model: "Outsourcing",
      Questions:
        "If managed hardware solution, can the circuits be brought into existing hardware?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions:
        "Describe the steps for migrating a hybrid WAN (MPLS primary, Internet backup) solution into a SDWAN? Are there no disruptiions?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "While Prisma SD-WAN is designed to operate as a router replacement, most deployments and evaluations begin with Prisma SD-WAN being inserted on the LAN side of an existing router.   Since Prisma SD-WAN does not leverage any routing protocols on the SD-WAN overlay, Prisma SD-WAN can be deployed transparently in line with no change to existing network routing topology or configuration enabling customers to cut in Prisma SD-WAN in the branch in a matter of minutes.\r\nAlternatively, Prisma SD-WAN can be configured as a router replacement.  If Private WAN (IE MPLS) is available at the site, traffic can be forwarded directly onto the private WAN underlay if destined to a non-Prisma SD-WAN Site.  This is delivered without compromising the end user experience by leveraging both our detailed WAN underlay metrics and application metrics. \r\n\r\nIf Private WAN underlay is not available locally at the site it can be sent to a DC or branch gateway location where the private WAN connectivity is available.",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions: "No other scalability limitations?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Device specifications are listed here: https://www.paloaltonetworks.com/apps/pan/public/downloadResource?pagePath=/content/pan/en_US/resources/datasheets/prisma-sd-wan-instant-on-network-ion-device-specifications",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer a Single Pane of Glass?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN is managed by Palo Alto Networks Strata Cloud Manager and is a 100% Secure REST API driven, microservices-based, cloud-native architecture that is designed to provide elasticity, availability, scale and agility for enterprise networks. Our controller is natively multi-tenanted managed service delivered from cloud which supports 1000s of tenants across multiple regions worldwide. Every function in the Prisma SD-WAN controller is available through APIs; this includes reporting, configuration and deployment capabilities. Customers use our automation capabilities for massive-scale deployments to successfully deploy hundreds of sites in minutes, while eliminating human error.  Our controller has an intuitive cloud portal for single pane of glass management of your network. \r\nOur managed service also ensures that the latest version of our SD-WAN controller software is always available to our customers once we push it into production.  ",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution allow management through the SSL portal? If yes does it support MFA and AD integration? SAML/SSO?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions: "Does the solution offer performance visibility?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions:
        "Does the solution support Third-Party Application Integration?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions: "Does solution not require an Engineer to Node?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions: "Does the solution offer API integration?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions:
        "Does the API provide access to 100% of the features and functions of the solution?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN is a 100% RESTful product where data exchange happens in JSON, making it easier to integrate with any 3rd party tools, allowing for programmatic control of the functions at scale. ",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Is the solution's management platform self-hosted, or vendor provided?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN primarily utilizes a cloud hosted management interface (Strata Cloud Manager).  Additionally, if required an on-prem version of the Prisma SD-WAN controller is available.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "If vendor-provided, what underlying platform is being used (GCP/AWS/Azure/etc.)? What's the support model? Are there no regional limitations?",
      Check: "Yes",
      Rating: 3,
      Notes:
        " Prisma SD-WAN showcases a controller architecture meticulously designed for seamless scalability, featuring controller availability across diverse regions, redundant services, and a clear separation of control and data planes. At the solution level, the data plane, management plane, and control plane are de-coupled, providing an architecture that adeptly addresses historical scalability challenges in large WAN networks. This design also allows for the elastic addition of capacity to scale out individual services and micro-services. This ensures a versatile solution capable of effortlessly scaling to thousands of sites, with both hardware and virtual device software supporting high availability and accommodating elastic site and throughput growth to meet the evolving needs of our customers.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "If not vendor-provided, how is it deployed/managed? How does it scale?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Ease of Use? (new employee turn-up, vendor-specific terminology)",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Describe the upgrade process required to upgrade the solution?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SDWAN provides enhanced software management capabilities where device upgrades can be split into software download (download of the software binary onto the device) and the upgrade/downgrade itself. Both of these processes can be configured with different timers attributed to each workflow to ensure a successful operation. Devices can be upgraded in bulk via APIs or via the Prisma SDWAN UI. \r\n\r\nFor cloud deployments, Prisma SDWAN software images are available on the marketplaces for several CSPs for consumption.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions: "Are there generative AI capabilities for management?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN leverages supervised machine learning to provide native real-time incident analysis that automatically correlates incidents and alerts, generates summary incidents, and suppresses the original incidents across a wide range of scenarios. This serves to reduce the troubleshooting time and with remediation playbooks easily identify the root cause.   \r\nEvent policies can be further applied by the administrator to train the system to identify flapping events, suppress anticipated alarms, and escalate alarms on a timer-basis or at critical locations. \r\nPrisma SD-WAN provides valuable insights powered by AI. These insights are generated after a deep analysis of utilization and application performance trends. Customers can use these insights for capacity planning, and making sure configurations are compliant and in tune per carrier provisioned specifications.\r\n\r\nWe also use deep learning to detect anomalies in bandwidth utilization and provide this information for consumption via the Prisma SD-WAN portal. This deep learning model also uses ARIMA to forecast capacity needs.\r\n\r\nDue to Prisma SDWAN's RESTful architecture, management of all of its resources can be easily done via APIs or by leveraging the Python SDK. Using our unique cloudblades infrastruture, we offer customers DevOps style management of their network, where resource updates can be tracked and overridden by the source of truth defined by the enduser. ",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions:
        "What is the licensing model for the solution? Please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Our Licensing model is an \"as a Service'' model. ION devices require a subscription license in order to enable the functionality required for the SD-WAN deployment. For ION devices deployed as a Data Center (DC), customers have to purchase one DC subscription per device that provides access to the features required for a DC site. For ION devices deployed in the Branch we offer flexible bandwidth subscriptions as part of our licensing model. Customers may purchase a bandwidth subscription per device, per branch site or as bandwidth on demand (aggregate bandwidth pool). For branch deployments that choose per-device bandwidth subscription, customers have the option to also include the following optional add-ons: \r\n\r\n- DVR: Ability to store all of our detailed WAN analytics data for 90 days (default 7 days)\r\n- WCR: Ability to access detailed standard and customizable reports including WAN Bandwidth usage, Circuit Utilization, Application Top Talkers, etc.\r\n\r\nAll SD-WAN subscriptions have a minimum term of one year and a maximum term of five years. ",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions: "Does the solution have an automation feature set?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Does the solution offer integration with other troubleshooting projects?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Does the solution support live packet capture for troubleshooting purposes?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The devices toolkit can capture tcpdump information which can either be viewed live or written to a file for analysis in tools such as WireShark.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions: "Does the management solution support inline ticket creation?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Prisma SD-WAN has integration to ticketing systems such as ServiceNOW and others that can auto create and remediate tickets based on defined events and alarms.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Can network administrator use the solution to troubleshoot an end-user specific reported application performance problem?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Our solution provides more visibility and active monitoring capabilities than that of any option on the market, but the true first line of defense is driven by big data and is about ensuring that you have a powerful application SLA model.  Prisma SD-WAN builds a self-driving self-healing network to minimize trouble ticketing, monitoring needs, and operational workload. \r\n\r\nHowever, Prisma SD-WAN has extensive monitoring/logging capabilities. All flows, stats, and logs are collected, aggregated, and analyzed in the centralized data lake.  Administrators can access this plethora of data via UI and API. This includes charts on network analytics, link quality, capacity, link status, media analytics, flow level details, and application specific performance details, with the ability to scroll back in time up to 90 days.    This is invaluable to administrators as they are doing live and in the past troubleshooting which requires the ability to get to flow level visibility and the state of the network at that time.    In addition to rich application metrics to assist with application performance analysis, the system also provides Integrated AIOPs capabilities for network & application events that are correlated and reduced down the root cause automatically thereby simplifying IT admins troubleshooting workflows by providing a starting point or an answer to the problem.\r\n\r\nAdditionally, Prisma SD-WAN as an API-centric solution allows customer to rapidly integrate SD-WAN into their existing IT applications and ITSM workflows with native integrations to tools such as ServiceNow.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Are there any native testing tools available for troubleshooting? If so, what are they?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "A full device toolkit CLI is available for on-box troubleshooting and minor configuration tasks such as changing interface configuration. Tools such as curl, tcpdump, ping, arping, traceroute, and session monitoring are available.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Does the solution offer Artificial Intelligence capabilities? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN leverages supervised machine learning to provide native real-time incident analysis that automatically correlates incidents and alerts, generates summary incidents, and suppresses the original incidents across a wide range of scenarios. This serves to reduce the troubleshooting time and with remediation playbooks easily identifying the root cause.   \r\nEvent policies can be further applied by the administrator to train the system to identify flapping events, suppress anticipated alarms, and escalate alarms on a timer-basis or at critical locations. \r\nPrisma SD-WAN provides valuable insights powered by AI. These insights are generated after a deep analysis of utilization and application performance trends. Customers can use these insights for capacity planning, and making sure configurations are compliant and in tune per carrier provisioned specifications.\r\n\r\nWe also use deep learning to detect anomalies in bandwidth utilization and provide this information for consumption via the Prisma SD-WAN portal. This deep learning model also uses ARIMA to forecast capacity needs.\r\n\r\nDue to Prisma SDWAN's RESTful architecture, management of all of its resources can be easily done via APIs or by leveraging the Python SDK. Using our unique cloudblades infrastruture, we offer customers DevOps style management of their network, where resource updates can be tracked and overridden by the source of truth defined by the enduser. ",
    },
    {
      Criteria: "Technical Support",
      Model: "All",
      Questions:
        "Does the solution offer 24/7 technical support with defined service levels for response and resolution time? ",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Technical Support",
      Model: "Insourcing/Co-Managed",
      Questions: "Is solution training available?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Palo Alto Networks offers multiple training options including Self Paced Digital Learning and Instructor lead courses.  (https://www.paloaltonetworks.com/services/education) Digital Learning is available through our Beacon Platform.  The Digital Learning  covers: Prisma SD-WAN infrastructure, how applications form the fundamental component of the Prisma SD-WAN solution, the CloudBlades platform, and DevOps-style automation. Additionally, learn the static and BGP routing topologies, alerts and alarms, branch devices, services, multitenancy aspects of the Prisma SD-WAN cloud controller, and how to troubleshoot network, device, and application issues.  Our Standard Instructor lead course, EDU-238 (https://www.paloaltonetworks.com/services/education/edu-238-prisma-sd-wan-design-and-operation), is 5 Days of hands-on experience that will help enhance an attendees understanding of how to design, implement, and effectively operate a Prisma SDWAN solution.  Palo Alto Networks and our partners can also provide custom training on request.  In addition to standard offers we provide regular learning opportunities via Webinars across Regional Events",
    },
    {
      Criteria: "Technical Support",
      Model: "Co-Managed/Outsourcing",
      Questions:
        "How long is an estimated MTTR of a defective gateway appliance (what are support options)?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Technical Support",
      Model: "Co-Managed/Outsourcing",
      Questions: "What are the SLA support options available, list.",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Technical Support",
      Model: "Co-Managed/Outsourcing",
      Questions: "Are there financial implications for breaching SLA, explain?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Are reporting capabilities available? Describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN delivers top-notch, actionable insights into network and application performance, facilitating effective network planning, issue resolution, and analytics directly within the user interface. Additional in-depth reporting is provided via the WAN Clarity reports as an add-on. https://www.paloaltonetworks.com/apps/pan/public/downloadResource?pagePath=/content/pan/en_US/resources/datasheets/prisma-sd-wan-dvr-reports\r\n\r\nFurthure more any customizable reports can be easily built based on data retrieved via the anayltics API",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "What types of data can be reported?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Our solution provides more visibility and active monitoring capabilities than that of any option on the market, but the true first line of defense is driven by big area is about ensuring that you have a powerful application SLA model.  Prisma SD-WAN builds a self-driving self-healing network to minimize trouble ticketing, monitoring needs, and operational workload. \r\n\r\nHowever, Prisma SD-WAN has extensive monitoring/logging capabilities. All flows, stats, and logs are collected, aggregated, and analyzed in the centralized data lake.  Administrators can access this plethora of data via UI and API. This includes charts on network analytics, link quality, capacity, link status, media analytics, flow level details, and application specific performance details, with the ability to scroll back in time up to 90 days.    This is invaluable to administrators as they are doing live and in the past troubleshooting which requires the ability to get to flow level visibility and the state of the network at that time.    In addition to rich application metrics to assist with application performance analysis, the system also provides Integrated AIOPs capabilities for network & application events that are correlated and reduced down the root cause automatically thereby simplifying IT admins troubleshooting workflows by providing a starting point or an answer to the problem.\r\n\r\nAdditionally, Prisma SD-WAN as an API-centric solution allows customer to rapidly integrate SD-WAN into their existing IT applications and ITSM workflows with native integrations to tools such as ServiceNow.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Can KPI data baselines be calculated automatically?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN can support custom reporting and KPI alignment utilizing the Rest API",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there network-wide insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN provides network-wide insights including application health, circuit health and metrics natively via the management portal.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there site-level insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN provides site level insights, per application, and per flow views natively - with 90 days historical data for analysis.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there device-level insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Device level health and information is included (CPU, Mem, Temp, interface level statistics, etc.)",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Are there link-level performance metrics available?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Cisco SD-WAN (Viptela) offers comprehensive link-level performance metrics via vManage. It tracks key parameters like latency, jitter, packet loss, and bandwidth utilization across all links.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there application-level insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN provides application related informations which includes Application health score, New flows, Transaction Stats",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are performance metrics available for sub-applications (e.g. Gmail vs. all Google apps)?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are full performance monitoring capabilities available for traffic using direct-to-internet paths?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Are there end-user insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN provides all flow and session level detail for the client/user IP from the sites for insights and troubleshooting.  ",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Can the data be reported in a visually appealing format? (Graphs, illustrations, etc.)",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Can data reporting be filtered by different time frames?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Is this solution application-aware?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions:
        "Can traffic be dynamically steered based on real-time network performance and application priority?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application bandwidth be detected?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application latency be detected?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application jitter be detected?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application loss be detected?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions:
        "Can the solution throttle at the application level (similar to application-based QoS policy)?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Can policies be built based on tagged traffic?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer granular security policies?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN provides a stateful, flexible, application-aware and enterprise Zone-Based Firewall (ZBFW) that secures an ever-changing WAN perimeter, facilitates segmentation within a branch.\r\nAs branches are added to the network, the policy set is extended to these branch devices automatically provisioning the security services to the edge.  Additionally, customers can leverage 3rd party cloud-based security services to enhance security to the edge.",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Is there an application policy enforcement feature?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution offer monitoring and policy control based on user identity and user group membership?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN supports User-ID based policies, wherein you can configure policies directly for a user or a group of users. You can use the user name or the group name as part of a policy rule for path, QoS, and security policies.",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution incorporate DLP mechanisms?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN deeply integrates with Prisma Access, our cloud-delivered security, and provides the following capabilities:\r\n1. FWaaS powered by core PAN-OS technology including App-ID, User-ID, Content-ID, SSL Decryption etc.\r\n2. SWG with explicit proxy support\r\n3. ZTNA with complete threat inspection/prevention\r\n4. CASB with inline and API-based visibility and control\r\n5. ML-Powered threat prevention including IPS/IDS, URL Filtering, WildFire (Malware Analysis), DNS Security, Enterprise DLP, IoT Security, etc.\r\n6. ADEM to provide digital experience management for all users\r\nIn addition, we have a built-in zone-based firewall on our ION SD-WAN appliances which provides granular segmentation based on user, policy, network and application to protect east to west traffic.",
    },
    {
      Criteria: "Security Policy",
      Model: "All",
      Questions: "Does the solution allows login based on SSO?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The solution provides role based access and supports SSO via Palo Alto Networks Customer Support Portal User access. Multiple MFA methods are available for CSP access, including integration with SAML iDP\r\n\r\nRole Based Access Control\r\nPrisma SD-WAN supports role based access control (RBAC) to execute network and security administration of enterprise networks through the Prisma SD-WAN web interface.\r\n \r\nSingle Sign On Access using SAML\r\nSecurity Assertion Markup Language (SAML) provides the ability to use customer specific authentication and authorization schemes to allow or deny end users access to the Prisma SD-WAN web interface.\r\n\r\nAudit Logs\r\nAudit logs are available through the Prisma SD-WAN web interface and provide records of administrators' configuration changes in a system. You can use these logs for compliance and troubleshooting purposes.",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "Does the solution offer protection for the SD-WAN edge devices? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN IONs are inherently hardened by design, automatically safeguarding internet ports. This design ensures that only authorized secure fabric connections are permitted, adding an extra layer of security to the network infrastructure.",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "Describe how secret key material is protected throughout the entire provisioning and de-provisioning lifecycle?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN devices are sent with a device certificate that is authenticated with the serial number and replaced with a customer installed certificate as a part of the device claiming process that verifies chain of custody of the device before being added to the customer's tenant/environment.  There are no key or secrets that are installed or provided on the device until it is claimed and configured by the customer.",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "If a unit is lost or compromised, how is key information protected?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "See above - the device will be marked as returned or lost and has no access to the environment until it is validated and claimed.",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "What mechanisms are in place to prevent a compromised unit from gaining network access?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "See above - the device will be marked as returned or lost and has no access to the environment until it is validated and claimed.",
    },
    {
      Criteria: "NAT",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can source and destination Network Address Translation (NAT) be configured?  -(Presently NAT to be done on the FWs)",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "NAT",
      Model: "Insourcing/Co-Managed",
      Questions:
        "What types of NAT are supported?  (Presently NAT to be done on the FWs)",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution meet U.S. encryption import/export guidelines and laws?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "All",
      Questions:
        "Does the solution use a single shared encryption key or multiple encryption keys between tunnels?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN subscribes to a defense in depth model starting from device authentication to ensure security of end-to-end communications, some of the functionality to ensure the security of these end-to-end comms are as follows:\r\n1. Before a Prisma SD-WAN device can join the network, the device’s installed certificate (stored in a TPM) is automatically authenticated by certificate and serial number by the controller against the customer’s purchased devices.  Once this is done, the administrator authorizes the devices via the UI before communications to the rest of the network can be established\r\n2. VPN Encryption keys are limited in scope to only a single connection between 2 nodes and in duration to a single hour.  There is no concept of shared keys and the keys not accessible to other devices or even the controller.  Hourly key rotation is done regardless of connectivity to the controller.  \r\n3. Prisma SD-WAN does NOT decrypt application flows and thus does not store any application specific crypto material.  This ensures application-level security and integrity is maintained within the system.",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "All",
      Questions:
        "Are tunnel encryption keys rotated? How often are tunnel keys rotated?",
      Check: "Yes",
      Rating: 3,
      Notes: "Keys are rotated hourly.",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "All",
      Questions:
        "Does the solution support latest standard for end-to-end traffic encryption? (AES- 256)",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution have stateful firewalling? ",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer Deep Packet Inspection?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN deeply integrates with Prisma Access, our cloud-delivered security, and provides the following capabilities:\r\n1. FWaaS powered by core PAN-OS technology including App-ID, User-ID, Content-ID, SSL Decryption etc.\r\n2. SWG with explicit proxy support\r\n3. ZTNA with complete threat inspection/prevention\r\n4. CASB with inline and API-based visibility and control\r\n5. ML-Powered threat prevention including IPS/IDS, URL Filtering, WildFire (Malware Analysis), DNS Security, Enterprise DLP, IoT Security, etc.\r\n6. ADEM to provide digital experience management for all users\r\nIn addition, we have a built-in zone-based firewall on our ION SD-WAN appliances which provides granular segmentation based on user, policy, network and application to protect east to west traffic.",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer an IDS & IPS feature?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN deeply integrates with Prisma Access, our cloud-delivered security, and provides the following capabilities:\r\n1. FWaaS powered by core PAN-OS technology including App-ID, User-ID, Content-ID, SSL Decryption etc.\r\n2. SWG with explicit proxy support\r\n3. ZTNA with complete threat inspection/prevention\r\n4. CASB with inline and API-based visibility and control\r\n5. ML-Powered threat prevention including IPS/IDS, URL Filtering, WildFire (Malware Analysis), DNS Security, Enterprise DLP, IoT Security, etc.\r\n6. ADEM to provide digital experience management for all users\r\nIn addition, we have a built-in zone-based firewall on our ION SD-WAN appliances which provides granular segmentation based on user, policy, network and application to protect east to west traffic.",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution offer antivirus and antimalware protection?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions: "Can security rules be put in place for layer 4-7?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions: "Are application/layer 7 rules supported?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can custom applications be defined based on URL or domain and subdomain? (E.g. example.com, crm.example.com)",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Do custom applications receive 100% of the feature/functionality as built-in/system applications?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions: "Does the solution have the ability to segment traffic?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions:
        "Describe how traffic may be separated for different device types and pools?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN supports several industry standard segmentation options; VLANs, Layer 7 Zone Based Firewall, and VRFs.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions:
        "When traffic separation is in place, is a different encryption key used for VPN tunnels?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Palo Alto’s Prisma SD-WAN (ION series) integrates with Prisma Access to provide segmented traffic isolation. Each VPN tunnel is secured with unique encryption keys, ensuring cryptographic isolation for traffic segments. The solution also supports traffic segmentation based on applications, users, and devices, leveraging Secure Access Service Edge (SASE) principles.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions: "Is the network segmentation capability PCI-compliant?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Palo Alto ION with Prisma Access provides PCI-compliant segmentation through application-aware policies, Zero Trust principles, and secure encryption mechanisms. It ensures proper isolation and auditing capabilities to meet PCI DSS requirements.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions: "How does segmentation integrate with legacy Infrastructure?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN supports several industry standard segmentation options; VLANs, Layer 7 Zone Based Firewall, and VRFs.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions:
        "Does SD-WAN solution capable to secure IoT devices? Is there a need for additional hardware to secure IoT?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN deeply integrates with Prisma Access, our cloud-delivered security, and provides the following capabilities:\r\n1. FWaaS powered by core PAN-OS technology including App-ID, User-ID, Content-ID, SSL Decryption etc.\r\n2. SWG with explicit proxy support\r\n3. ZTNA with complete threat inspection/prevention\r\n4. CASB with inline and API-based visibility and control\r\n5. ML-Powered threat prevention including IPS/IDS, URL Filtering, WildFire (Malware Analysis), DNS Security, Enterprise DLP, IoT Security, etc.\r\n6. ADEM to provide digital experience management for all users\r\nIn addition, we have a built-in zone-based firewall on our ION SD-WAN appliances which provides granular segmentation based on user, policy, network and application to protect east to west traffic.",
    },
    {
      Criteria: "DDOS Protection",
      Model: "Co-Managed/Outsourcing",
      Questions: "How is DDOS Protection Supported/Achieved",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN IONs are inherently hardened by design, automatically safeguarding internet ports. This design ensures that only authorized secure fabric connections are permitted, adding an extra layer of security to the network infrastructure.",
    },
    {
      Criteria: "FIPS Compliant",
      Model: "All",
      Questions: "Is the device FIPS Compliant?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "FIPS Compliant",
      Model: "All",
      Questions: "Are there any other Compliance Standards?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Prisma SD-WAN platforms are submitted for FIPS 140-3 certification\r\n\r\nPrisma SD-WAN solution is certified for IRAP and SOC-2 standards and follows the ISO/IEC 27002:2013 standard",
    },
  ],
};
